import { render, staticRenderFns } from "./CoursesSlider1.vue?vue&type=template&id=75852aad&scoped=true&"
import script from "./CoursesSlider1.vue?vue&type=script&lang=js&"
export * from "./CoursesSlider1.vue?vue&type=script&lang=js&"
import style0 from "./CoursesSlider1.vue?vue&type=style&index=0&id=75852aad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75852aad",
  null
  
)

export default component.exports